import type { ReactNode } from "react";

interface RailGroupProps {
  /** Group title shown in the header (e.g., "Applications", "Files"). */
  title: string;
  /** Optional right-side action element (e.g., a "View all" button). */
  action?: ReactNode;
  /** Rail entries to render inside the group. */
  children: ReactNode;
}

/**
 * Rail group — Foundry-style grouped section with a header (title + action)
 * and a body of rail entries. Matches sidebar-group / sidebar-group-header
 * pattern from Foundry's workspace sidebar.
 */
export function RailGroup({ title, action, children }: RailGroupProps) {
  return (
    <div data-testid="rail-group" className="bp-rail-group">
      <div className="bp-rail-group-header">
        <div className="bp-rail-group-title">{title}</div>
        {action && <div className="bp-rail-group-right">{action}</div>}
      </div>
      {children}
    </div>
  );
}
